module.exports = __webpack_public_path__ + "img/question.d3c35152.svg";